import React, { useState, useEffect } from 'react';
import { useStateSelector } from '../../../../store/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import PortalTooltip from '../../../../components/PortalTooltip/PortalTooltip';
import { DocumentInfo } from '../../../../models/DocumentInfo/DocumentInfo';
import moment from 'moment';
import '../../../../components/DocumentListCard/DocumentListCard.scss';
import '../../../../components/DocumentTile/DocumentTile.scss';
import './ConnectMarketplaceAgreements.scss';
import termsOfServicePdf from '../../../../assets/documents/Buyer_Terms_of_Service_12-09-2025.pdf';

const ConnectMarketplaceAgreements = () => {
    const axios = useStateSelector((state) => state.core.axios);
    const [documentList, setDocumentList] = useState<DocumentInfo[]>([]);

    const getDocuments = () => {
        setDocumentList([]);

        const requiredDocumentsRequests = [
            axios.post('/api/Documents/GetDocumentUrl', { DocTypeId: 1 }),
            axios.post('/api/Documents/GetSignedDocument', { DocTypeId: 1 }),
        ];

        Promise.allSettled(requiredDocumentsRequests)
            .then((result) => {
                const newDocumentList: DocumentInfo[] = [];

                const ndaUrlResponse = result[0] as any;
                const ndaSignedResponse = result[1] as any;

                if (ndaUrlResponse.value?.data?.data) {
                    const documentInfo = ndaSignedResponse.value?.data;
                    newDocumentList.push({
                        name: 'Mutual NDA',
                        source: ndaUrlResponse.value.data.data,
                        date: documentInfo?.uploadedOn
                            ? new Date(documentInfo.uploadedOn)
                            : undefined,
                    });
                }

                setDocumentList(newDocumentList);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setDocumentList((prevList) => [
                    ...prevList,
                    {
                        name: 'Marketplace Addendum',
                        source: termsOfServicePdf,
                    },
                ]);
            });
    };

    const getTooltipId = (index: number, name: string) => {
        return `agreement-tooltip-${index}-${name.replace(/\s+/g, '-')}`;
    };

    const openFile = (source: string) => {
        window.open(source, '_blank');
    };

    useEffect(() => {
        getDocuments();
    }, []);

    return (
        <div className="connect-marketplace-agreements">
            <div className="documents-container">
                {documentList.map((item, index) => (
                    <div
                        key={`document-${index}-${item.name}`}
                        style={{ width: 142, height: 60 }}
                        className="document-tile"
                        onClick={() => openFile(item.source)}>
                        <div className="icon-container">
                            <FontAwesomeIcon
                                inverse
                                className="icon"
                                icon={faFileAlt as any}
                            />
                        </div>
                        <div className="file-info">
                            <div>
                                <div 
                                    className="file-name"
                                    id={getTooltipId(index, item.name)}>
                                    {item.name}
                                </div>
                                {item.date ? (
                                    <div className="file-date">
                                        {moment(item.date).format('L')}
                                    </div>
                                ) : null}
                            </div>
                            <PortalTooltip
                                anchorId={getTooltipId(index, item.name)}
                                delayShow={300}
                                place="top"
                                content={item.name}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConnectMarketplaceAgreements;
